export default __webpack_public_path__ + "static/media/ai.5ef652ad.jpeg";